import React from 'react';

export default function AttendeeForm({index, attendee, onChange, onRemove}) {
  return (
    <div className="attendee-form">
      <label>
        Name:
        <input value={attendee.name} onChange={e=>onChange(index,'name',e.target.value)} />
      </label>
      <label>
        Email:
        <input value={attendee.email} onChange={e=>onChange(index,'email',e.target.value)} />
      </label>
      <label>
        Phone:
        <input value={attendee.phone} onChange={e=>onChange(index,'phone',e.target.value)} />
      </label>
      <button onClick={()=>onRemove(index)}>Remove</button>
    </div>
  );
}
